import {Injectable} from '@angular/core';
import {CommonService} from '@services/common';
import {DownloadHistoryUpdatedPayload} from '@services/download-history/download-history.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadHistoryService extends CommonService {
  private readonly _baseUrl = `${this.apiUrl}/download-history`;

  getDownloadHistoryByOperationId(operationId: string): Observable<DownloadHistoryUpdatedPayload> {
    return this._http.get<DownloadHistoryUpdatedPayload>(`${this._baseUrl}/${operationId}`);
  }
}
